import { Button, Card, Image, LoadingShimmer } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import ExternalLinkIcon from "@/icons/ExternalLinkIcon";
import FormativeLogoIcon from "@/icons/FormativeLogoIcon";
import useFormativeWebTokenGet from "@/view/utils/useFormativeWebTokenGet";
import GRAPHIC_ORGANIZER_GRADE_BANDS from "./GraphicOgranizerGradeBands.constants";
import {
  cardCss,
  ctaCss,
  detailsCss,
  externalLinkIconCss,
  formativeIconCss,
  greyLight,
  loadingShimmerCss,
  printCtaCss,
  imageCss,
  rootCss,
} from "./FormativeGraphicOrganizerButton.style";

const propTypes = {
  contentId: PropTypes.string,
  formativeDestination: PropTypes.string.isRequired,
  gradeBand: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const FormativeGraphicOrganizerButton = ({
  contentId,
  formativeDestination,
  gradeBand,
  imageUrl,
  title,
}) => {
  const { data: formativeJwtResponse, loading: jwtReponseLoading } =
    useFormativeWebTokenGet({ contentId, formativeDestination });

  const shouldDisplayFormative = !jwtReponseLoading && formativeJwtResponse;

  if (!jwtReponseLoading && !formativeJwtResponse) return null;

  const gradeBandText = `${GRAPHIC_ORGANIZER_GRADE_BANDS[gradeBand][0]}-${GRAPHIC_ORGANIZER_GRADE_BANDS[gradeBand][1]}`;

  const eventProperties = {
    objectType: objectTypes.user,
    actionName: actionNames.navigate,
    streamProperties: {
      description: `Navigate to ${title} graphic organizer on formative`,
      content_id: contentId,
    },
  };

  return (
    <Card __css={cardCss}>
      {jwtReponseLoading && (
        <LoadingShimmer
          __cssFor={{ root: loadingShimmerCss }}
          backgroundColor={greyLight}
        />
      )}
      {shouldDisplayFormative && (
        <form method="post" action={formativeJwtResponse.url} target="_blank">
          <input
            name="id_token"
            type="hidden"
            value={formativeJwtResponse.payload}
          />
          <ButtonWithTrackEvent
            __cssFor={{ root: rootCss }}
            ariaProps={{
              "aria-label": `${title} graphic organizer. Opens in new tab`,
            }}
            dataProps={{
              "data-qa-selector": "formative-graphic-organizer-button",
            }}
            flavor={Button.flavors.incognito}
            isFullWidth
            type="submit"
            {...eventProperties}
          >
            <Image
              __css={imageCss}
              alt={`preview of ${title} graphic organizer`}
              src={imageUrl}
            />
            <div css={detailsCss}>
              <h2>GRADE {gradeBandText}</h2>
              <div css={ctaCss}>
                <h3>{title}</h3>
                <ExternalLinkIcon css={externalLinkIconCss} />
              </div>
              <div css={printCtaCss}>
                <FormativeLogoIcon __cssFor={{ root: formativeIconCss }} />
                <p>Open & print in Formative</p>
              </div>
            </div>
          </ButtonWithTrackEvent>
        </form>
      )}
    </Card>
  );
};

FormativeGraphicOrganizerButton.propTypes = propTypes;

export default FormativeGraphicOrganizerButton;
